import { useContext, useState } from "react";
import { ConfiguracoesContext } from "../../../contexts/Configuracoes/ConfiguracoesContext";
import { EmpresaContext } from "../../../contexts/Empresa/EmpresaContext";
import { useTheme } from "../../../contexts/Theme/ThemeContext";
import Titulo from "../../Modal/ModaisConfigsPrimeiroAcesso/Titulo/Titulo";
import { ModalOrdenacaoCategorias } from "../../Modal/ModalOrdenacaoCategorias/ModalOrdenacaoCategorias";
import { Select } from "../../Select";
import { Toggle } from "../../Toggle/Toggle";
import { ContainerVisualContainer } from "./style";
import { ReactComponent as InfoSvg } from "../../../assets/newImages/icons/info.svg";
import comBordaImg from "../../../assets/preview/com_borda.png";
import semBordaImg from "../../../assets/preview/sem_borda.png";

// IDs de empresas liberadas para escolher o layout do catalogo (rollout controlado).
const EMPRESAS_LAYOUT_LIBERADO: number[] = [];

interface VisualProps {
  configIn: "empresa" | "configuracoes";
}

export const Visual: React.FC<VisualProps> = ({ configIn }) => {
  const { configuracoes, setConfiguracoes } = useContext(ConfiguracoesContext);
  const { empresa } = useContext(EmpresaContext);
  const idEmpresa = empresa?.id;
  const isProducao = window.location.hostname === "www.painel.conectavenda.com.br";
  const layoutLiberado = !isProducao || (idEmpresa !== undefined && EMPRESAS_LAYOUT_LIBERADO.includes(idEmpresa));
  const [modalOrdenacao, setModalOrdenacao] = useState(false);
  const [showPreview, setShowPreview] = useState(false);
  const valuesProdutos = [
    {
      nome: "Menor preço",
      chave: "produto_variacoes[0].variacao_preco",
      inverso: false,
    },
    {
      nome: "Maior preço",
      chave: "produto_variacoes[0].variacao_preco",
      inverso: true,
    },
    { nome: "Mais novos", chave: "produto_data_criacao", inverso: true },
    { nome: "Mais antigos", chave: "produto_data_criacao", inverso: false },
    { nome: "Nome A-Z", chave: "produto_nome", inverso: false },
    { nome: "Nome Z-A", chave: "produto_nome", inverso: true },
    { nome: "Descrição A-Z", chave: "produto_descricao", inverso: false },
    { nome: "Descrição Z-A", chave: "produto_descricao", inverso: true },
    { nome: "SKU A-Z", chave: "produto_referencia", inverso: false },
    { nome: "SKU Z-A", chave: "produto_referencia", inverso: true },
    { nome: "Estoque crescente", chave: "produto_estoque_total", inverso: false },
    { nome: "Estoque decrescente", chave: "produto_estoque_total", inverso: true },
  ];

  const valuesVariacoes = [
    { nome: "Por ordem de cadastro", chave: "variacao_id", inverso: false },
    { nome: "Variação A-Z", chave: "variacao_descricao", inverso: false },
    { nome: "Variação Z-A", chave: "variacao_descricao", inverso: true },
    {
      nome: "Menor preço",
      chave: "variacao_preco_sem_desconto",
      inverso: false,
    },
    {
      nome: "Maior preço",
      chave: "variacao_preco_sem_desconto",
      inverso: true,
    },
  ];

  const valuesCategorias = [
    { nome: "Categoria A-Z", chave: "categoria_nome", inverso: false },
    { nome: "Categoria Z-A", chave: "categoria_nome", inverso: true },
    { nome: "Manual", chave: "categoria_ordenacao_manual", inverso: false },
  ];

  const valuesSubcategorias = [
    { nome: "Subcategoria A-Z", chave: "subcategoria_nome", inverso: false },
    { nome: "Subcategoria Z-A", chave: "subcategoria_nome", inverso: true },
  ];

  const ordensProdutos = [
    { name: "Menor preço", value: "Menor preço" },
    { name: "Maior preço", value: "Maior preço" },
    { name: "Mais novos", value: "Mais novos" },
    { name: "Mais antigos", value: "Mais antigos" },
    { name: "Nome A-Z", value: "Nome A-Z" },
    { name: "Nome Z-A", value: "Nome Z-A" },
    { name: "Descrição A-Z", value: "Descrição A-Z" },
    { name: "Descrição Z-A", value: "Descrição Z-A" },
    { name: "SKU A-Z", value: "SKU A-Z" },
    { name: "SKU Z-A", value: "SKU Z-A" },
    { name: "Estoque crescente", value: "Estoque crescente" },
    { name: "Estoque decrescente", value: "Estoque decrescente" },
  ];

  const ordensVariacoes = [
    { name: "Por ordem de cadastro", value: "Por ordem de cadastro" },
    { name: "Variação A-Z", value: "Variação A-Z" },
    { name: "Variação Z-A", value: "Variação Z-A" },
    { name: "Menor preço", value: "Menor preço" },
    { name: "Maior preço", value: "Maior preço" },
  ];

  const ordensCategorias = [
    { name: "Categoria A-Z", value: "Categoria A-Z" },
    { name: "Categoria Z-A", value: "Categoria Z-A" },
    { name: "Manual", value: "Manual" },
  ];

  const ordensSubcategorias = [
    { name: "Subcategoria A-Z", value: "Subcategoria A-Z" },
    { name: "Subcategoria Z-A", value: "Subcategoria Z-A" },
  ];

  const { theme } = useTheme();

  return (
    <>
      <ContainerVisualContainer configIn={configIn} theme={theme}>
        {configIn === "empresa" && (
          <Titulo titulo="Visual" subtitulo={"Configure seu catálogo"} />
        )}
        <div className="informacoes">
          {layoutLiberado && (
            <Select
              label="Layout do catálogo"
              sizeLabel="small"
              placeholder="Layout A"
              options={[
                { name: "Layout A", value: "layoutA" },
                { name: "Layout B", value: "layoutB" },
                { name: "Layout C", value: "layoutC" },
              ]}
              value={configuracoes.catalogo.layout || "layoutA"}
              onChange={(value) => {
                setConfiguracoes({
                  ...configuracoes,
                  catalogo: {
                    ...configuracoes.catalogo,
                    layout: value as "layoutA" | "layoutB" | "layoutC",
                  },
                });
              }}
            ></Select>
          )}
          <Select
            label="Ordenação dos produtos"
            sizeLabel="small"
            placeholder="Nome A-Z"
            options={ordensProdutos}
            value={configuracoes.ordenacao_catalogo.nome}
            onChange={(value) => {
              setConfiguracoes({
                ...configuracoes,
                ordenacao_catalogo: valuesProdutos.find(
                  (item) => item.nome === value,
                )!,
              });
            }}
          ></Select>
          <Select
            label="Ordenação das variações"
            sizeLabel="small"
            placeholder="Por ordem de cadastro"
            options={ordensVariacoes}
            value={configuracoes.ordenacao_catalogo_variacoes.nome}
            onChange={(value) => {
              setConfiguracoes({
                ...configuracoes,
                ordenacao_catalogo_variacoes: valuesVariacoes.find(
                  (item) => item.nome === value,
                )!,
              });
            }}
          ></Select>
          <Select
            label="Ordenação das categorias"
            sizeLabel="small"
            placeholder="Nome A-Z"
            options={ordensCategorias}
            value={configuracoes.ordenacao_catalogo_categorias?.nome || "Categoria A-Z"}
            onChange={(value) => {
              const categoriaConfig = valuesCategorias.find(
                (item) => item.nome === value,
              )!;
              setConfiguracoes({
                ...configuracoes,
                ordenacao_catalogo_categorias: {
                  ...categoriaConfig,
                  ordenacao: configuracoes.ordenacao_catalogo_categorias?.ordenacao || [],
                },
              });
              if (categoriaConfig.chave === "categoria_ordenacao_manual") {
                setModalOrdenacao(true);
              }
            }}
          ></Select>
          <Select
            label="Ordenação das subcategorias"
            sizeLabel="small"
            placeholder="Subcategoria A-Z"
            options={ordensSubcategorias}
            value={configuracoes.ordenacao_catalogo_subcategorias?.nome || "Subcategoria A-Z"}
            onChange={(value) => {
              setConfiguracoes({
                ...configuracoes,
                ordenacao_catalogo_subcategorias: valuesSubcategorias.find(
                  (item) => item.nome === value,
                )!,
              });
            }}
          ></Select>
        </div>
        <div className="configuracoesFotos">
          <div className="tituloConfig fonteSubtitulo">Configurações de fotos</div>
          <div className="togglesContainer">
            <div className="toggleContainer fonteTexto">
              <Toggle
                value={configuracoes.zoom_fotos}
                onChange={(value) => {
                  setConfiguracoes({
                    ...configuracoes,
                    zoom_fotos: value,
                  });
                }}
              ></Toggle>
              <span>Permitir zoom de fotos</span>
            </div>

            <div className="toggleContainer fonteTexto">
              <Toggle
                value={configuracoes.download_fotos}
                onChange={(value) => {
                  setConfiguracoes({
                    ...configuracoes,
                    download_fotos: value,
                  });
                }}
              ></Toggle>
              <span>Permitir download de fotos no catálogo</span>
            </div>

            <div className="toggleContainer fonteTexto">
              <Toggle
                value={configuracoes.download_fotos_pedido}
                onChange={(value) => {
                  setConfiguracoes({
                    ...configuracoes,
                    download_fotos_pedido: value,
                  });
                }}
              ></Toggle>
              <span>Exibir botão de download de fotos nos detalhes do pedido</span>
            </div>

            <div className="toggleContainer fonteTexto">
              <Toggle
                value={
                  configuracoes.catalogo.aplicar_efeito_visual_imagem ?? false
                }
                onChange={(newValue) => {
                  setConfiguracoes({
                    ...configuracoes,
                    catalogo: {
                      ...configuracoes.catalogo,
                      aplicar_efeito_visual_imagem: newValue,
                    },
                  });
                }}
              ></Toggle>
              <span>Aplicar efeito visual na imagem do produto</span>
              <div
                className="info-icon-container"
                onMouseEnter={() => setShowPreview(true)}
                onMouseLeave={() => setShowPreview(false)}
              >
                <InfoSvg style={{ width: 16, height: 16, marginLeft: 8, cursor: 'pointer' }} />
                {showPreview && (
                  <div className="preview-tooltip">
                    <div className="preview-item">
                      <img src={semBordaImg} alt="Sem efeito" />
                      <span>Sem efeito</span>
                    </div>
                    <div className="preview-item">
                      <img src={comBordaImg} alt="Com efeito" />
                      <span>Com efeito</span>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </ContainerVisualContainer>
      <ModalOrdenacaoCategorias
        isOpen={modalOrdenacao}
        setModal={setModalOrdenacao}
        ordenacaoAtual={configuracoes.ordenacao_catalogo_categorias?.ordenacao || []}
        onSave={(categorias) => {
          setConfiguracoes({
            ...configuracoes,
            ordenacao_catalogo_categorias: {
              ...configuracoes.ordenacao_catalogo_categorias,
              ordenacao: categorias.map((cat) => ({ id: cat.id, nome: cat.descricao })),
            },
          });
        }}
      />
    </>
  );
};
